export default "__VITE_ASSET__CYcCnKUH__"